import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Badge,
  TextField,
  IconButton,
  InputAdornment,
  Paper,
  Typography,
  Divider,
  Toolbar,
  AppBar,
  Tooltip,
  Chip,
  Fade,
  CircularProgress,
  Button,
} from "@mui/material";
import {
  Send as SendIcon,
  Search as SearchIcon,
  AttachFile as AttachFileIcon,
  Mood as MoodIcon,
  MoreVert as MoreVertIcon,
  Call as CallIcon,
  Videocam as VideocamIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  DoneAll as DoneAllIcon,
  Schedule as ScheduleIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  FilterList as FilterListIcon,
  Refresh as RefreshIcon,
  Delete as DeleteIcon,
  Block as BlockIcon,
  Archive as ArchiveIcon,
  MarkChatRead as MarkChatReadIcon,
} from "@mui/icons-material";
import axios from "axios";
import { formatDistanceToNow, format } from "date-fns";
import moment from "moment";
const Messages = (props) => {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  console.log(selectedChat, "testing Chats");
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const messagesEndRef = useRef(null);
  const token = localStorage.getItem("Token");
  const userEmail = localStorage.getItem("Emailaddress");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  // Styles
  const styles = {
    container: {
      display: "flex",
      // height: "96vh",
      marginBottom: "10px",
      backgroundColor: "#f5f7fb",
      fontFamily: '"Segoe UI", "Roboto", sans-serif',
    },
    sidebar: {
      width: 380,
      backgroundColor: "#ffffff",
      borderRight: "1px solid #e0e0e0",
      display: "flex",
      flexDirection: "column",
      boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
    },
    sidebarHeader: {
      padding: "20px 16px",
      backgroundColor: "#fff",
      borderBottom: "1px solid #e0e0e0",
    },
    userProfile: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "20px",
    },
    avatarLarge: {
      width: 48,
      height: 48,
      backgroundColor: "#1976d2",
      fontSize: "1.2rem",
      fontWeight: "bold",
    },
    searchBox: {
      backgroundColor: "#f0f2f5",
      borderRadius: 20,
      padding: "8px 16px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    chatList: {
      flex: 1,
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "3px",
      },
    },
    chatItem: {
      padding: "16px",
      borderBottom: "1px solid #f0f0f0",
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#f8f9fa",
      },
      "&.selected": {
        backgroundColor: "#e3f2fd",
        borderLeft: "4px solid #1976d2",
      },
    },
    chatAvatar: {
      width: 40,
      height: 40,
      fontSize: "0.9rem",
      backgroundColor: "#e91e63",
    },
    onlineIndicator: {
      width: 12,
      height: 12,
      backgroundColor: "#4caf50",
      borderRadius: "50%",
      border: "2px solid #fff",
      position: "absolute",
      bottom: 0,
      right: 0,
    },
    chatContent: {
      padding: "8px 16px",
      borderRadius: 16,
      maxWidth: "70%",
      marginBottom: 8,
      position: "relative",
    },
    sentMessage: {
      backgroundColor: "#1976d2",
      color: "#fff",
      marginLeft: "auto",
      borderBottomRightRadius: 4,
    },
    receivedMessage: {
      backgroundColor: "#fff",
      color: "#212121",
      marginRight: "auto",
      border: "1px solid #e0e0e0",
      borderBottomLeftRadius: 4,
    },
    messageTime: {
      fontSize: "0.75rem",
      opacity: 0.8,
      marginTop: 4,
      display: "flex",
      alignItems: "center",
      gap: 4,
    },
    messageInputContainer: {
      padding: "16px",
      backgroundColor: "#fff",
      borderTop: "1px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    messageInput: {
      flex: 1,
      "& .MuiOutlinedInput-root": {
        borderRadius: 24,
        backgroundColor: "#f0f2f5",
      },
    },
    sendButton: {
      backgroundColor: "#1976d2",
      color: "#fff",
      width: 48,
      height: 48,
      "&:hover": {
        backgroundColor: "#1565c0",
      },
      "&.Mui-disabled": {
        backgroundColor: "#e0e0e0",
      },
    },
    chatHeader: {
      backgroundColor: "#fff",
      borderBottom: "1px solid #e0e0e0",
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    messagesContainer: {
      flex: 1,
      padding: "20px",
      maxHeight: "50vh",
      overflowY: "auto",
      backgroundImage: "linear-gradient(180deg, #f5f7fb 0%, #e3f2fd 100%)",
      display: "flex",
      flexDirection: "column",
    },
    dateSeparator: {
      textAlign: "center",
      margin: "16px 0",
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: 0,
        right: 0,
        height: "1px",
        backgroundColor: "#e0e0e0",
      },
    },
    dateLabel: {
      backgroundColor: "#fff",
      padding: "4px 12px",
      borderRadius: 12,
      border: "1px solid #e0e0e0",
      fontSize: "0.75rem",
      color: "#666",
      position: "relative",
      display: "inline-block",
    },
    loadingSpinner: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    },
    noChatSelected: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      color: "#999",
      textAlign: "center",
    },
    emojiPicker: {
      position: "absolute",
      bottom: 80,
      right: 16,
      zIndex: 1000,
      backgroundColor: "#fff",
      borderRadius: 8,
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      padding: "8px",
    },
  };

  // Fetch chats on component mount
  useEffect(() => {
    // fetchChats();
    fetchConversation();
  }, [refresh]);

  // Fetch messages when selected chat changes
  useEffect(() => {
    if (selectedChat) {
      fetchConversation(selectedChat.userEmail);
    }
  }, [selectedChat]);

  // Scroll to bottom when messages change
  useEffect(() => {
    scrollToBottom();
  }, [messages, refresh]);

  //   const fetchChats = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_URL}/Messages/getChats`,
  //         { headers }
  //       );

  //       const sortedChats = response.sort(
  //         (a, b) => new Date(b.LastMessageDate) - new Date(a.LastMessageDate)
  //       );

  //       setChats(sortedChats);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching chats:", error);
  //       setLoading(false);
  //     }
  //   };

  const PatientInfo = props.Patientinfo;
  const fetchConversation = async (otherEmail) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Messages/getConversationWith?otherEmail=${PatientInfo.emailAddress}`,
        { headers }
      );

      // Response data
      const conversation = response.map((msg) => ({
        id: msg.id,
        sentBy: msg.sentBy,
        sentTo: msg.sentTo,
        body: msg.body,
        sendDate: msg.sendDate,
        isRead: msg.isRead,
      }));

      setMessages(conversation);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching conversation:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    const markUnreadMessages = async () => {
      if (!selectedChat || !selectedChat.unreadMessageIds?.length) return;

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/Messages/markAsRead`,
          selectedChat.unreadMessageIds,
          { headers }
        );
        // fetchChats();
      } catch (error) {
        console.error("Error marking messages as read:", error);
      }
    };

    markUnreadMessages();
  }, [selectedChat]);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    const today = moment().format("MM/DD/YYYY HH:mm:ss");
    const PatientName = `{${PatientInfo.lastName} ${PatientInfo.firstName}}`;
    const messageData = {
      id: 0,
      sentBy: userEmail,
      sentTo: PatientInfo.emailAddress ? PatientInfo.emailAddress : PatientName,
      body: newMessage.trim(),
      sendDate: today,
      createdBy: userEmail,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Messages/sendMessage`,
        messageData,
        { headers }
      );

      setRefresh(true);
      fetchConversation(response.sentBy);

      // Update chats list (last message, date, unread)
      // updateChatsList(selectedChat.userEmail, newMsg.body);

      // Clear input & close emoji picker
      setNewMessage("");
      setShowEmojiPicker(false);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  //   const updateChatsList = (userEmail, lastMessage) => {
  //     setChats(prev => {
  //       const updatedChats = prev.map(chat =>
  //         chat.userEmail === userEmail
  //           ? {
  //               ...chat,
  //               lastMessage,
  //               lastMessageDate: new Date().toISOString(),
  //               unreadCount: 0
  //             }
  //           : chat
  //       );

  //       // Bring updated chat to top
  //       const currentChatIndex = updatedChats.findIndex(chat => chat.userEmail === userEmail);
  //       const currentChat = updatedChats[currentChatIndex];
  //       updatedChats.splice(currentChatIndex, 1);
  //       updatedChats.unshift(currentChat);

  //       return updatedChats;
  //     });
  //   };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const formatTime = (date) => {
    return moment(date).format("hh:mm A");
  };

  // Date formatting: Today / Yesterday / MMMM d, yyyy
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = moment(dateString);
    if (!date.isValid()) return "";

    const today = moment();
    const yesterday = moment().subtract(1, "days");

    if (date.isSame(today, "day")) {
      return "Today";
    } else if (date.isSame(yesterday, "day")) {
      return "Yesterday";
    } else {
      return date.format("MMMM D, YYYY"); // e.g., December 3, 2025
    }
  };
  const filteredChats = chats.filter(
    (chat) =>
      chat.userEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (chat.lastMessage || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getInitials = (email) => {
    return email.charAt(0).toUpperCase();
  };

  const getRandomColor = (email) => {
    const colors = [
      "#e91e63",
      "#9c27b0",
      "#673ab7",
      "#3f51b5",
      "#2196f3",
      "#03a9f4",
      "#00bcd4",
      "#009688",
      "#4caf50",
      "#8bc34a",
    ];
    const index = email.length % colors.length;
    return colors[index];
  };

  const emojis = [
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😅",
    "😂",
    "🤣",
    "😊",
    "😇",
    "🙂",
    "🙃",
    "😉",
    "😌",
    "😍",
    "🥰",
    "😘",
    "😗",
    "😙",
    "😚",
    "😋",
    "😛",
    "😝",
    "😜",
    "🤪",
    "🤨",
    "🧐",
    "🤓",
    "😎",
    "🤩",
    "🥳",
    "😏",
    "😒",
    "😞",
    "😔",
    "😟",
    "😕",
    "🙁",
    "☹️",
    "😣",
    "😖",
    "😫",
    "😩",
    "🥺",
    "😢",
    "😭",
    "😤",
    "😠",
    "😡",
    "🤬",
    "🤯",
    "😳",
    "🥵",
    "🥶",
    "😱",
    "😨",
    "😰",
    "😥",
    "😓",
    "🤗",
    "🤔",
    "🤭",
    "🤫",
    "🤥",
    "😶",
    "😐",
    "😑",
    "😬",
    "🙄",
    "😯",
    "😦",
    "😧",
    "😮",
    "😲",
    "🥱",
    "😴",
    "🤤",
    "😪",
    "😵",
    "🤐",
    "🥴",
    "🤢",
    "🤮",
    "🤧",
    "😷",
    "🤒",
    "🤕",
    "🤑",
    "🤠",
    "😈",
    "👿",
    "👹",
    "👺",
    "🤡",
    "💩",
    "👻",
    "💀",
    "☠️",
    "👽",
    "👾",
    "🤖",
    "🎃",
    "😺",
    "😸",
    "😹",
    "😻",
    "😼",
    "😽",
    "🙀",
    "😿",
    "😾",
    "👐",
    "🙌",
    "👏",
    "🙏",
    "🤝",
    "👍",
    "👎",
    "👊",
    "✊",
    "🤛",
    "🤜",
    "🤞",
    "✌️",
    "🤟",
    "🤘",
    "👌",
    "🤏",
    "✋",
    "🤚",
    "🖐️",
    "🖖",
    "👋",
    "🤙",
    "💪",
    "🦾",
    "🦵",
    "🦿",
    "🦶",
    "👂",
    "👃",
    "🧠",
    "🫀",
    "🫁",
    "🦷",
    "🦴",
    "👀",
    "👁️",
    "👅",
    "👄",
  ];
  const [openNewMessageModal, setOpenNewMessageModal] = useState(false);
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [newMessageText, setNewMessageText] = useState("");
  const [showPatientsList, setShowPatientsList] = useState(false);
  const fetchPatients = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Patients/getPatients`,
        { headers }
      );

      setPatients(response);
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  return (
    <Box style={styles.container}>
      {/* Sidebar */}
      {/* <Box style={styles.sidebar}>
        <Box style={styles.sidebarHeader}>
          <Box style={styles.userProfile}>
            <Avatar style={styles.avatarLarge}>
              <PersonIcon />
            </Avatar>
            <Box>
              <Typography variant="h6" style={{ fontWeight: 600 }}>
                Messages
              </Typography>
            </Box>
          </Box>
          
          <Box style={styles.searchBox}>
            <SearchIcon color="action" />
            <TextField
              fullWidth
              placeholder="Search messages..."
              variant="standard"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{ disableUnderline: true }}
            />
          </Box>
        </Box>

        <Box style={{ padding: '0 8px', marginTop: 8 }}>
          <Chip 
            icon={<GroupIcon />} 
            label=" New Conversation" 
            onClick={() => {
                setShowPatientsList(true);
                fetchPatients();
            }}
            style={{ marginRight: 8, backgroundColor: '#e3f2fd' }}
          />
        </Box>

        <List style={styles.chatList}>
          {loading && !chats.length ? (
            <Box style={styles.loadingSpinner}>
              <CircularProgress />
            </Box>
          ) : (
            filteredChats.map((chat) => (
              <ListItem
                key={chat.userEmail}
                style={{
                  ...styles.chatItem,
                  ...(selectedChat?.userEmail === chat.userEmail ? { backgroundColor: '#e3f2fd', borderLeft: '4px solid #1976d2' } : {})
                }}
                onClick={() => setSelectedChat(chat)}
              >
                <ListItemAvatar>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    variant="dot"
                    color={chat.online ? 'success' : 'default'}
                  >
                    <Avatar style={{ backgroundColor: getRandomColor(chat.userEmail) }}>
                      {getInitials(chat.userEmail)}
                    </Avatar>
                  </Badge>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                        {chat.userEmail.split('@')[0]}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {formatDistanceToNow(new Date(chat.lastMessageDate), { addSuffix: true })}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography 
                        variant="body2" 
                        color="textSecondary" 
                        style={{ 
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '200px'
                        }}
                      >
                        {chat.lastMessage}
                      </Typography>
                      {chat.unreadCount > 0 && (
                        <Chip 
                          label={chat.unreadCount} 
                          size="small" 
                          style={{ backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' }}
                        />
                      )}
                    </Box>
                  }
                />
              </ListItem>
            ))
          )}
        </List>
        {showPatientsList && (
  <List style={{ ...styles.chatList, maxHeight: 250, overflowY: 'auto' }}>
    {patients.map((patient) => (
      <ListItem
        key={patient.id}
        style={{
          cursor: 'pointer',
          backgroundColor: selectedPatient?.id === patient.id ? '#e3f2fd' : 'transparent',
        }}
        onClick={() => {
          setSelectedChat({
            userEmail: patient.emailAddress,
            lastMessage: '',
            unreadCount: 0,
          });
          setSelectedPatient(patient);
          setShowPatientsList(false); // Collapse list after selection
        }}
      >
        <ListItemAvatar>
          <Avatar style={{ backgroundColor: getRandomColor(patient.emailAddress) }}>
            {getInitials(patient.emailAddress)}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={`${patient.firstName}${patient.lastName}`}
          secondary={patient.emailAddress}
        />
      </ListItem>
    ))}
  </List>
)}

      </Box> */}

      {/* Main Chat Area */}
      <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Chat Header */}
        <Box style={styles.chatHeader}>
          <Box display="flex" alignItems="center" gap={2}>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              variant="dot"
              color={"success"}
            >
              <Avatar
                style={{
                  backgroundColor: getRandomColor`${PatientInfo.firstName}`,
                }}
              >
                {/* {`${PatientInfo.firstName} ${PatientInfo.lastName}`} */}
              </Avatar>
            </Badge>
            <Box>
              <Typography variant="h6" style={{ fontWeight: 600 }}>
                {`${PatientInfo.firstName} ${PatientInfo.lastName}`}
              </Typography>
              {/* <Typography variant="body2" color={selectedChat.online ? 'primary' : 'textSecondary'}>
                    {selectedChat.online ? 'Online' : 'Last seen recently'}
                  </Typography> */}
            </Box>
          </Box>

          {/* <Box display="flex" gap={1}>
                <Tooltip title="Voice Call">
                  <IconButton>
                    <CallIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Video Call">
                  <IconButton>
                    <VideocamIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Chat Info">
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="More Options">
                  <IconButton>
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
              </Box>  */}
          <Box display="flex" gap={1}>
            <Tooltip title="Refresh">
              <IconButton onClick={() => {setRefresh(!refresh)}}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Messages Container */}
        <Box style={styles.messagesContainer}>
           <Box
    style={{
      textAlign: "center",
      padding: "12px 0",
      fontSize: "1rem",
      fontWeight: "600",
      color: "#4a4a4a",
      borderBottom: "1px solid #e0e0e0",
      marginBottom: "10px",
    }}
  >
    You Are Communicating Securely with the Patient
  </Box>
          {loading && !messages.length ? (
            <Box style={styles.loadingSpinner}>
              <CircularProgress />
            </Box>
          ) : (
            messages.map((message, index) => {
              const isMine = message.sentBy === userEmail;

              const showDate =
                index === 0 ||
                formatDate(messages[index - 1].sendDate) !==
                  formatDate(message.sendDate);

              return (
                <React.Fragment key={message.id}>
                  {showDate && (
                    <Box style={styles.dateSeparator}>
                      <Chip
                        label={formatDate(message.sendDate)}
                        style={styles.dateLabel}
                      />
                    </Box>
                  )}

                  {/* Message Row */}
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: isMine ? "flex-end" : "flex-start",
                      marginBottom: 8,
                    }}
                  >
                    {/* Message Bubble */}
                    <Paper
                      elevation={1}
                      style={{
                        ...styles.chatContent,
                        backgroundColor: isMine ? "#d1edff" : "#f1f0f0",
                        borderRadius: 14,
                        padding: "8px 12px",
                        maxWidth: "70%",
                      }}
                    >
                      {/* SENT BY NAME */}
                      <Typography
                        variant="caption"
                        style={{
                          fontSize: "0.7rem",
                          color: "#666",
                          display: "block",
                          marginBottom: 4,
                          textAlign: isMine ? "right" : "left",
                        }}
                      >
                        {message.sentBy}
                      </Typography>

                      {/* MESSAGE TEXT */}
                      <Typography
                        variant="body1"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {message.body}
                      </Typography>

                      {/* TIME + READ STATUS */}
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: isMine ? "flex-end" : "flex-start",
                          marginTop: 4,
                          fontSize: "0.75rem",
                          color: "#777",
                        }}
                      >
                        {formatTime(message.sendDate)}

                        {/* Read/unread only for my messages */}
                        {isMine &&
                          (message.isRead ? (
                            <DoneAllIcon
                              fontSize="small"
                              style={{ color: "#4fc3f7", marginLeft: 4 }}
                            />
                          ) : (
                            <CheckCircleIcon
                              fontSize="small"
                              style={{ opacity: 0.5, marginLeft: 4 }}
                            />
                          ))}
                      </Box>
                    </Paper>
                  </Box>
                </React.Fragment>
              );
            })
          )}
          <div ref={messagesEndRef} />
        </Box>

        {/* Message Input */}
        <Box
          component="form"
          onSubmit={sendMessage}
          style={styles.messageInputContainer}
        >
          {/* <Tooltip title="Attach File">
                <IconButton>
                  <AttachFileIcon />
                </IconButton>
              </Tooltip> */}

          <TextField
            fullWidth
            placeholder="Type your message..."
            variant="outlined"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            style={styles.messageInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title="Insert Emoji">
                    <IconButton
                      onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    >
                      <MoodIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />

          <IconButton
            type="submit"
            style={styles.sendButton}
            disabled={!newMessage.trim()}
          >
            <SendIcon />
          </IconButton>

          {showEmojiPicker && (
            <Fade in={showEmojiPicker}>
              <Paper style={styles.emojiPicker}>
                <Box
                  display="flex"
                  gap={1}
                  flexWrap="wrap"
                  width={250}
                  maxHeight={200}
                  overflow="auto"
                >
                  {emojis.map((emoji, index) => (
                    <IconButton
                      key={index}
                      onClick={() => {
                        setNewMessage((prev) => prev + emoji);
                        setShowEmojiPicker(false);
                      }}
                      style={{ fontSize: "1.5rem" }}
                    >
                      {emoji}
                    </IconButton>
                  ))}
                </Box>
              </Paper>
            </Fade>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Messages;
